<template>
  <div>

    <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
                <div class="row mt-3">
                  <label class="control-label col-md-2">品牌：</label>
                  <div class="col-md-3">
                    <select
                          id="brands-code"
                          name="brandsCode"
                          class="form-control"
                          v-model="search.brandCode"
                        >
                        <option
                          v-for="x in selectListBrands"
                          v-bind:value="x.Code"
                          :key="x.Code"
                        >{{x.Text}}</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2">店號：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.code" placeholder="請輸入店號">
                  </div>
                  <label class="control-label col-md-2">店名：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.name" placeholder="模糊搜尋">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2">日期：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="search.sdate" max="9999-12-31">
                  </div>
                    <label class="control-label">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="search.edate" max="9999-12-31">
                  </div>
                  <div class="col-md-3" style="text-align:right">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
            </div>
          </div>
        </b-card>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <h3></h3>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                          <tr>
                            <th>品牌</th>
                            <th>日期</th>
                            <th>店號</th>
                            <th>店名</th>
                            <th>關閉時間</th>
                            <th>關閉原因</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x) in items" :key="x.ID" :id="x.ID">
                            <td>{{x.BrandCode}}</td>
                            <td>{{x.WorkDate | formatDate}}</td>
                            <td>{{x.StoreCode}}</td>
                            <td>{{x.StoreName}}</td>
                            <td>{{x.CreatedAt | formatFullDate}}</td>
                            <td>{{x.Memo}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="totalRows" v-model="search.currentPage" :per-page="pageRows" @change="changePage"></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>

          </div>
        </div>
      </b-card>

    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import VModal from 'vue-js-modal'
import axios from 'axios'
miniToastr.init()
export default {
  data () {
    return {
      search: {
        brandCode: '',
        sdate: '',
        edate: '',
        code: '',
        name: '',
        currentPage: 1
      },
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      md_id: 0,
      md_title: '',
      md_imgUrl: undefined,
      md_week: [],
      md_item: [],
      md_OptionProducts: '',
      API_URL: API_URL,
      FunctionPermission: 0,
      optionsWeek: [
        { text: '一', value: 1 },
        { text: '二', value: 2 },
        { text: '三', value: 3 },
        { text: '四', value: 4 },
        { text: '五', value: 5 },
        { text: '六', value: 6 },
        { text: '日', value: 0 }
      ],
      lists: [],
      selectListBrands: [{ ID: 0, Code: '', Text: '全部' }]
    }
  },
  created () {
    this.setdate()
    this.querySelectListBrands()
    this.FunctionPermission = getFunctionPermission('F34') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
      console.log(this.search)
      this.query()
    } else {
      this.reset()
    }
  },
  methods: {
    reset () {
      this.sdate = '',
      this.edate = '',
      this.search.code = ''
      this.search.name = ''
      this.search.currentPage = 1
      this.search.brandCode = ''
      this.querySelectListBrands()

      this.query()
    },
    btnQuery () {
      this.search.currentPage = 1
      this.query()
    },
    query () {
      var brandcode, sdate, edate, name, code, page, pageRows
      brandcode = this.search.brandCode
      sdate = this.search.sdate
      edate = this.search.edate
      name = this.search.name
      code = this.search.code
      page = this.search.currentPage
      pageRows = this.pageRows

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getPagePostClose', {
        brandcode: brandcode,
        sdate: sdate,
        edate: edate,
        code: code,
        name: name,
        page: page,
        pageRows: pageRows
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.items = response.data.data
            this.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage = page // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.pageRows * (this.search.currentPage - 1) + 1;
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.pageRows > response.data.count) ? response.data.count : (this.search.currentPage * this.pageRows) >= response.data.count ? response.data.count : this.search.currentPage * this.pageRows;
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    showDetail (item) {
      this.md_week = JSON.parse('[' + item.Week + ']');
      this.md_item = item
      this.md_imgUrl = item.ImageURL
      this.getOption(item.ID)
      this.$refs.mdDetail.show()
    },
    showDelete (item) {
      this.md_id = item.ID
      this.md_title = item.Title
      this.$refs.mdDelete.show()
    },
    delCancel () {
      this.$refs.mdDelete.hide()
    },
    delConfirm () {
      this.$refs.mdDelete.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/deletecombo/v1', {
        id: this.md_id
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('套餐已刪除')
            this.query()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    getOption (ID) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getComboOptions/v1', {
        status: ID
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.lists = response.data.data
            for (var p in response.data.data) {
              var product = ''
              for (var i in response.data.data[p].OptionProduct) {
                if (i === '0') {
                  product = response.data.data[p].OptionProduct[i].Name
                } else {
                  product = product + '、' + response.data.data[p].OptionProduct[i].Name
                }
              }
              this.lists[p].OptionProduct = product
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '搭配資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '搭配資料讀取異常2')
          console.log(error)
        })
    },
    setdate () {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth() - 2, 0)
      // 若三個月後的最後一天比當天的日期大，則可以設定當天日期為三個月後的日期
      if (firstDay.getDate() >= date.getDate()) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 3, date.getDate())
      }
      var lastDay = date
      this.search.sdate = this.dateFormat(firstDay)
      this.search.edate = this.dateFormat(lastDay)
    },
    dateFormat (date) {
      var year = date.getFullYear()
      var mon = ('0' + (date.getMonth() + 1)).substr(-2, 2)
      var day = ('0' + date.getDate()).substr(-2, 2)
      return year + '-' + mon + '-' + day
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          response.data.data.forEach(item => {
              if (!this.selectListBrands.some(existingItem => existingItem.ID === item.ID)) {
                  this.selectListBrands.push(item)
              }
          })
          this.$parent.Loading = false
        })
        .catch(error => {
          this.selectListBrands = []
          this.$parent.Loading = false
          miniToastr.error(error, "資料讀取異常")
          console.log(error)
        })
    }
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      return year + '/' + mon + '/' + day
    },
    formatFullDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      var sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min + ':' + sec
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 320px;
  height: 270px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/storeholiday/poscloselist.vue